import { StatusBadge } from "./status-badge";

const DOCSTATUS_LABEL: Record<number, string> = {
  0: "Draft",
  1: "Submitted",
  2: "Cancelled",
};

type DocStatusBadgeProps = {
  docstatus: number;
  className?: string;
};

/** Maps numeric docstatus (0/1/2) to a labeled StatusBadge with correct color. */
export function DocStatusBadge({ docstatus, className }: DocStatusBadgeProps) {
  const label = DOCSTATUS_LABEL[docstatus] ?? "Unknown";
  return (
    <StatusBadge className={className}>{label}</StatusBadge>
  );
}
